<template>
  <b-row>
    <b-col md="12">
      <div class="d-flex justify-content-right profile-maindv">
        <!-- Profile Image, Name, and Special Member -->

        <div class="profile-img">
          <img
            :src="profileImage"
            width="100px"
            class="mr-3"
            alt
            v-if="profileImage"
          />
          <img src="/img/profile.png" width="100px" alt v-else />
        </div>
        <div class="profile-detail">
          <h5 class="mt-2 font-16">
            {{ fullName }}
          </h5>
          <p class="my-2 phoneNumberPara" v-if="userPhone">
            <b-icon icon="telephone-fill" aria-label="Help"></b-icon>
            <span class="ml-1 mb-2"> {{ userPhone }}</span>
          </p>
          <p
            v-if="defaultAddress && Object.keys(defaultAddress).length > 0"
            class="mb-2 phoneNumberPara"
          >
            <b-icon icon="geo-alt-fill" aria-label="Help"></b-icon>
            {{ defaultAddress.street2 }}, {{ defaultAddress.city }},
            {{ defaultAddress.state }}, {{ defaultAddress.zip }}
          </p>
        </div>

        <!-- Edit Icon -->
        <div v-if="editKey" class="edit-icon margin-left">
          <a @click="goToEdit" style="cursor: pointer" class="d-flex text-dark">
            <b-icon icon="pencil-fill" aria-label="Help"></b-icon>
            {{ $t("edit") }}
          </a>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "show-edit-profile",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      defaultAddress: (state) => state.address.defaultAddress,
      userData: (state) => state.profile.userData,
    }),
    profileImage() {
      return this.userData?.extendedAttributes?.profilePhoto || "";
    },
    userPhone() {
      return this.userInfo?.authentication?.phone || "";
    },
    fullName() {
      const { first, last } = this.userInfo?.name || {};
      return first === last ? first : `${first} ${last}`;
    },
  },
  props: {
    editKey: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goToEdit() {
      this.$router.push("/edit-profile");
    },
    isNotAccepted(str) {
      if (!str) return false;
      // Regex for a 40-character hexadecimal string (SHA-1 hash-like)
      const hexPattern = /^[0-9a-fA-F]{40}$/;
      return !hexPattern.test(str); // Return true if string is NOT a 40-char hex
    },
  },
  async mounted() {
    await this.$store.dispatch("profile/getCustomerData", this.userInfo._id);
    await this.$store.dispatch("profile/getExternalInfoCustomer", {});
  },
};
</script>

<style scoped>
#modal-profile h3 {
  color: #0e8225;
}
::v-deep #modal-profile .mdi-menu-down {
  border: none;
  box-shadow: none;
  background-color: #fff !important;
}
::v-deep #modal-profile .custom-select {
  border: none;
  border-bottom: 1px solid #717171;
  border-radius: 0px;
}
.profile-img-upload {
  position: relative;
}
.edit-img-box {
  height: 480px;
  width: 480px;
}
.profile-img-upload .upload-icon {
  z-index: 1;
  position: absolute;
  top: 0;
  margin-left: 15px;
  cursor: pointer;
}
.preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-box img {
  max-width: 100%;
  height: auto;
  border-radius: 50%;
  margin: auto;
  object-fit: cover;
}
.set-img {
  width: 100px;
  padding: 3px;
  border-radius: 8px;
}
.set-img p {
  display: inline-block;
  margin-bottom: 0px;
  margin-left: 6px;
  font-size: 14px;
  font-weight: 600;
}
.edit-btn {
  border: 2px solid #272727;
}
.delete-btn {
  border: 2px solid #ff6d59;
  color: #ff6d59;
}
.profile-maindv {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 15px;
  border: 1px solid #d6d6d6;
  position: relative;
  gap: 10px;
}
.profile-img img {
  border-radius: 50%;
  padding: 2px;
  border: 1px solid #4a4a4a;
}
.margin-left {
  margin-left: 150px;
}
.edit-icon svg {
  margin-right: 7px;
  margin-top: 4px;
}
.profile-section {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.contact-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.profile-detail {
  margin-left: 10px;
}
.profile-detail .phoneNumberPara {
  word-break: break-all;
}
.edit-icon {
  margin-left: auto;
}
@media (max-width: 768px) {
  .edit-icon {
    margin-left: auto;
    position: absolute;
    top: 20px;
    right: 30px;
  }
}
</style>
